import script from "./Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Edit.vue?vue&type=script&setup=true&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=1596d906&lang=scss"

const __exports__ = script;

export default __exports__